import { AdminPreferences, SearchInterface } from "@amzn/ask-legal-domain";
import { Select, SelectProps } from "@amzn/awsui-components-react";
import { Builder } from "builder-pattern";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { withFirstPage } from "./search-filter-utils-v2";

const DEFAULT_PAGE_SIZE = 10;

export const PaginationSettingV2 = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    prefs: AdminPreferences.PaginationOptions[];
    disabled?: boolean;
}) => {
    const options: SelectProps.Option[] = props.prefs.map(v => ({ label: `${v}`, value: `${v}` }));
    const pageSize = `${props.queryInputState.value.pageSize || DEFAULT_PAGE_SIZE}`;
    const selectedOption = options.find(o => o.value === pageSize) || { label: pageSize, value: pageSize };

    const onChange = (value: string | undefined) => {
        const size = Number(value) || DEFAULT_PAGE_SIZE;
        props.queryInputState.setValue(withFirstPage(
            Builder<SearchInterface.SearchQueryInput>(props.queryInputState.value).pageSize(size).build()
        ));
    };

    return (
        <Select
            inlineLabelText="Results per page"
            selectedOption={selectedOption}
            options={options}
            disabled={props.disabled}
            onChange={({ detail }) => onChange(detail.selectedOption.value)}
            selectedAriaLabel="Selected"
        />
    );
};
